import { passwordStrength, defaultOptions } from 'check-password-strength';
import { SPECIAL_SYMBOLS } from '../constants';
export const getPasswordStrength = (value) => passwordStrength(value, defaultOptions, SPECIAL_SYMBOLS);
